// Cancel a return or exchange bill from the Fashion bag. Return lines can't be
// deleted one by one (Core blocks it), so dropping the whole bill is the only
// way out. Nothing has been saved or synced for it yet, so this only clears the
// on-screen bill and the return/exchange state Core keeps beside it.
import useTransactionStore from "../../stores/useTransactionStore";
import useCartStore from "../../stores/useCartStore";

const hasTakenPayment = (cart) => (cart?.payments || []).some((p) => Number(p?.amount || 0) !== 0);

export function cancelReturnBlockedReason(cart, exchangeCart) {
  if (cart?.isReturn !== true) return "This isn't a return bill.";
  if (hasTakenPayment(cart) || hasTakenPayment(exchangeCart)) return "A payment is already on this bill. Remove it on the pay screen first.";
  return null;
}

// deleteCart(true, type): `true` writes Core's delete-order log when the till
// keeps one; a type keeps the bill number the return was showing for the next
// bill (with no type Core moves two numbers ahead, leaving a gap).
export function cancelReturnBill({ deleteCart }) {
  const { cart, exchangeCart } = useCartStore.getState();
  const blocked = cancelReturnBlockedReason(cart, exchangeCart);
  if (blocked) return { ok: false, message: blocked };
  if (typeof deleteCart !== "function") return { ok: false, message: "This till can't cancel the bill here." };
  deleteCart(true, "cancelledReturn");
  const tx = useTransactionStore.getState();
  useCartStore.getState().setExchangeCart(null);
  tx.setSelectedReturnType(null);
  tx.setReturnThisReceipt(null);
  tx.setRefundReturnCustomerId(null);
  tx.setSalesReturn("N");
  tx.setSalesReturnApproved(false);
  return { ok: true };
}
